import fnsFormat from 'date-fns/format';
import { PromotionStatus } from '../types.es.js';
import { t } from '../i18n.es.js';

const formatPrice = (price) => {
  return price ? price.toLocaleString("vi-VN") : price;
};
const formatPriceFull = (price) => {
  return price || price === 0 ? price.toLocaleString("vi-VN", {
    style: "currency",
    currency: "VND"
  }) : price;
};
const sortItems = (childItems) => {
  return childItems.sort((left, right) => left.displayPriority > right.displayPriority ? 1 : -1);
};
const getComboName = (childItems) => {
  if (childItems.length === 0)
    return "";
  const primary = sortItems(childItems)[0];
  const comboLength = childItems.length;
  return comboLength === 1 ? primary.name : t("{{PrimaryName}} v\xE0 {{var0}} s\u1EA3n ph\u1EA9m kh\xE1c", {
    PrimaryName: primary.name,
    var0: comboLength - 1
  });
};
const getComboImageUrl = (childItems) => {
  if (childItems.length === 0)
    return [];
  return sortItems(childItems).map((item) => {
    var _a, _b;
    return item.imageUrl || ((_b = (_a = item.product) == null ? void 0 : _a.productInfo) == null ? void 0 : _b.imageUrl);
  });
};
const getDateStringWithFormat = (dateString, format = "HH:mm dd/MM/yyyy") => {
  try {
    return fnsFormat(new Date(dateString), format);
  } catch (e) {
    return "";
  }
};
var PromoItemType = /* @__PURE__ */ ((PromoItemType2) => {
  PromoItemType2["GIFT"] = "gift";
  PromoItemType2["DISCOUNT"] = "discount";
  PromoItemType2["VOUCHER"] = "voucher";
  return PromoItemType2;
})(PromoItemType || {});
const getAppliedPromotionsByCartPromotionGroupList = (cartPromotionGroupList) => {
  const gifts = [];
  cartPromotionGroupList.forEach((blockPromotion) => {
    blockPromotion.promotions.forEach((promotion) => {
      if (promotion.cartPromotionId !== null) {
        gifts.push({
          imageUrl: promotion.imageUrl,
          name: promotion.title
        });
      }
    });
  });
  return gifts;
};
const getPromotionStatus = (cartPromotionId, isSelectable) => {
  if (cartPromotionId === null && isSelectable) {
    return PromotionStatus.UNSELECTED;
  } else if (cartPromotionId === null && !isSelectable) {
    return PromotionStatus.DISABLED;
  } else if (cartPromotionId !== null && isSelectable) {
    return PromotionStatus.SELECTED;
  } else {
    return PromotionStatus.FIXED;
  }
};

export { PromoItemType, formatPrice, formatPriceFull, getAppliedPromotionsByCartPromotionGroupList, getComboImageUrl, getComboName, getDateStringWithFormat, getPromotionStatus };
